import React from 'react';
import {Field} from 'redux-form';
import {SketchPicker} from 'react-color';
import {FormattedMessage} from 'react-intl';

import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Paper from '@material-ui/core/Paper';
import PropTypes from "prop-types";

class ColorPicker extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.generateComponent = this.generateComponent.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleOpen = this.handleOpen.bind(this);

        this.state = {
            open: false
        };
    }

    generateComponent(props) {
        const {disabled, helpButton, input, label, messageId, meta: {active, error, touched, warning}, open, ...rest} = props;

        return (
            <FormControl className="color-picker" disabled={disabled}>
                <InputLabel htmlFor={rest.field} shrink>
                    {messageId ? <FormattedMessage id={messageId}/> : label}
                    {helpButton}
                </InputLabel>
                <div className="inline">
                    <Paper className="color-swatch" style={{backgroundColor: input.value}}/>
                    <Button
                        color="primary"
                        onClick={this.handleOpen}
                        variant="outlined"
                    >
                        <FormattedMessage id="buttons.pickColor"/>
                    </Button>
                </div>
                {do {
                    if (open) {
                        <ClickAwayListener
                            onClickAway={this.handleClose}
                        >
                            <SketchPicker
                                color={input.value}
                                disableAlpha
                                onChange={values => input.onChange(values.hex)}
                            />
                        </ClickAwayListener>;
                    }
                }}
                <FormHelperText error={!!error ? !!error : undefined}>
                    {do {
                        if (touched && !!error) {
                            error;
                        } else if (active && touched && !error && !!warning) {
                            warning;
                        }
                    }}
                </FormHelperText>
            </FormControl>
        );
    }

    handleClose() {
        this.setState({open: false});
    }

    handleOpen() {
        this.setState({open: true});
    }

    render() {
        const {show, ...rest} = this.props;

        if (show !== undefined && !show) {
            return null;
        }

        return (
            <span className="input">
                <Field
                    component={this.generateComponent}
                    name={rest.field}
                    open={this.state.open}
                    {...rest}
                />
            </span>
        );
    }
}

ColorPicker.propTypes = {
    field: PropTypes.string.isRequired,
    fullWidth: PropTypes.bool,
    helpButton: PropTypes.node,
    label: PropTypes.string,
    messageId: PropTypes.string,
    show: PropTypes.bool
};

export default ColorPicker;


// WEBPACK FOOTER //
// ./src/components/common/form/ColorPicker.js